import { Button } from "@amzn/awsui-components-console";
import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Top-right action shared by every admin page: starts a new MAMBA chat by
 * navigating to the chat view. Client-side navigation (not an anchor) so the
 * SPA doesn't do a full page reload.
 */
const NewChatButton: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Button iconName="add-plus" onClick={() => navigate("/")}>
      New MAMBA chat
    </Button>
  );
};

export default NewChatButton;
